import React from 'react';
import Register from 'components/auth/Register';
import { withGuestGuard } from 'components/auth/withGuestGuard';

const RegisterPage = () => {
    return (
        <div className="container max-w-md mx-auto pt-12 pb-24">
            <Register />
        </div>
    );
};

export default withGuestGuard(RegisterPage);
